module.exports = __webpack_public_path__ + "components/rewards/snowtrex/static/snowtrex-c038c1553ba6ac0cbf5b04d3bb7373a8.png";